import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { Row } from 'reactstrap';
import { RemindersFromMaintenancePlanResponseDTO } from '../../models/Reminders/RemindersFromMaintenancePlanResponseDTO';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import { Utilities } from '../../helpers/Utilities';
import { EditReminderDTO } from '../../models/Reminder/EditReminderDTO';
import Toast from '../../helpers/Toast';
import { ReminderService } from '../../services/ReminderService';
import useValidationSchema, { FieldConfig } from '../Validations';

export type EditReminderComponentProps = {
    Edit: (data: RemindersFromMaintenancePlanResponseDTO | null) => void;
    CurrentReminder: RemindersFromMaintenancePlanResponseDTO | null;
    SetCurrentReminder: React.Dispatch<React.SetStateAction<RemindersFromMaintenancePlanResponseDTO | null>>;
    OnClose: () => void;
    IsOpen: boolean;
}

export default function EditReminderComponent(props: EditReminderComponentProps) {
    const intl = useIntl();
    const reminderService = new ReminderService();

    const [currentReminderDate, setCurrentReminderDate] = useState<string | null>(null);
    const [currentReminderDayOfWeek, setCurrentReminderDayOfWeek] = useState<string | null>(null);

    const [newReminderDate, setnewReminderDate] = useState<string | null>(null);
    const [newDayOfWeek, setNewDayOfWeek] = useState<string | null>(null);

    const [motive, setMotive] = useState<string | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.IsOpen === true && props.CurrentReminder) {

            const formattedDate = props.CurrentReminder.reminderDate
                ? new Date(props.CurrentReminder.reminderDate.split('-').reverse().join('-')).toISOString().split('T')[0]
                : '';

            setCurrentReminderDate(formattedDate);
            setCurrentReminderDayOfWeek(props.CurrentReminder.reminderDayOfWeek);
        }
    }, [props.IsOpen, props.CurrentReminder]);

    useEffect(() => {
        setNewDayOfWeek(
            newReminderDate ? Utilities.CalculateDayOfWeek(newReminderDate) : null
        );
    }, [newReminderDate]);


    // Validações (campo, tipo dados, mensagem (pt.json))
    const fields: FieldConfig[] = [
        ["reminderId", "number", "EditReminderComponent.Validation.ReminderIdRequired"],
        ["reminderDate", "date", "EditReminderComponent.Validation.ReminderDateRequired"],
        ["motive", "string", "EditReminderComponent.Validation.MotiveRequired"]
    ];
    const schemaClientValidation = useValidationSchema(fields);

    const EditReminder = async () => {
        setIsLoading(true);

        const editReminder: EditReminderDTO = {
            reminderId: Number(props.CurrentReminder?.reminderId),
            reminderDate: new Date(`${newReminderDate}`),
            motive: motive ?? null
        };

        const { error } = schemaClientValidation.validate(editReminder);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setIsLoading(false);
            return;
        }
        const response = await reminderService.Edit(editReminder);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        Toast.Show("success", response.message);
        setIsLoading(false);

        props.Edit(null);
    };

    return (
        <Dialog open={props.IsOpen} fullWidth={true} maxWidth="xs">
            <DialogTitle textAlign={'center'}>
                {intl.formatMessage({ id: "EditReminderComponent.Title" })}
            </DialogTitle>

            <DialogContent>
                <Row>
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"date"}
                        value={currentReminderDate}
                        label={intl.formatMessage({ id: "EditReminderComponent.CurrentDate" })}
                        readOnly={true}
                    />
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={currentReminderDayOfWeek ?? ''}
                        label={intl.formatMessage({ id: "EditReminderComponent.CurrentDayOfWeek" })}
                        readOnly={true}
                    />
                </Row>

                <Row>
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"date"}
                        value={newReminderDate ?? ''}
                        label={intl.formatMessage({ id: "EditReminderComponent.NewDate" })}
                        readOnly={false}
                        onChange={(date: string) => setnewReminderDate(date)}
                    />
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={newDayOfWeek ?? ''}
                        label={intl.formatMessage({ id: "EditReminderComponent.NewDayOfWeek" })}
                        readOnly={true}
                    />
                </Row>

                <Row>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"textArea"}
                        value={motive ?? ''}
                        label={intl.formatMessage({ id: "EditReminderComponent.Motive" })}
                        readOnly={false}
                        onChange={(motive: string) => setMotive(motive)}
                    />
                </Row>
            </DialogContent>

            <DialogActions className="loginbuttons">
                <ButtonComponent
                    onClick={EditReminder}
                    className="enteraccount"
                    style={{ width: "97%", borderRadius: "5px", margin: "20px" }}
                    text={intl.formatMessage({ id: "EditReminderComponent.Button.Edit" })}
                    loading={isLoading}
                />
                <ButtonComponent
                    onClick={props.OnClose}
                    className="enteraccount"
                    style={{ width: "100%", borderRadius: "5px", margin: "20px" }}
                    text={intl.formatMessage({ id: "EditReminderComponent.Button.Cancel" })}
                    loading={isLoading}
                />
            </DialogActions>
        </Dialog>
    );
}